import React from 'react';

const Footer = () => {
  return (
    <div className="chat-footer">
      By using ChatWDL, you agree to our <a href="https://app.welldatalabs.com/Account/Terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> and have reviewed our <a href="https://app.welldatalabs.com/Account/Privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </div>
  );
};

export default Footer; 